Vendd.Scripts.load(function () {

    $('.x-control.x-article-reviews-summary[data-type="reviews-summary"]').each(function (i, wrapper) {

        var $wrapper = $(wrapper);

        var sessionIsAuthenticated = $wrapper.data('session-is-authenticated'); 
        if ($wrapper.find('> input[type="hidden"][data-member="isauthenticated"]').length > 0)
            articleReviewdByCurrentUser = $wrapper.find('> input[type="hidden"][data-member="isauthenticated"]').val() === 'true';

        var articleReviewdByCurrentUser = $wrapper.data('article-reviewd-by-current-user');
        if ($wrapper.find('> input[type="hidden"][data-member="isreviewed"]').length > 0)
            articleReviewdByCurrentUser = $wrapper.find('> input[type="hidden"][data-member="isreviewed"]').val() === 'true';

        var $loginPopup = $('div[data-type="review-login-popup"]', $wrapper);

        if (articleReviewdByCurrentUser) {

            var $scrollToReviewsLink = $('*[data-click="scrol-to-reviews"]', $wrapper);
            $scrollToReviewsLink.click(function (e) {

                scrollTo('reviews');

            });


        } else {
            
            if (sessionIsAuthenticated) {

                $loginPopup.remove();
                var $scrollToFormLink = $('*[data-click="scrol-to-form"]', $wrapper);
                $scrollToFormLink.click(function (e) {
                    
                    scrollTo('form');
                    
                });


            } else {
                
                if ($loginPopup.length == 0) throw new Error("login popUp does not exist on article review box");

                var $showLoginMessageLink = $('*[data-click="show-login-message"]', $wrapper);
                $showLoginMessageLink.click(function (e) {
                    $loginPopup.show();
                });

                var $loginLink = $('*[data-click="login"]', $loginPopup);
                var $registerLink = $('*[data-click="register"]', $loginPopup);
                var $closeBtn = $('*[data-click="close-popup"]', $loginPopup);

                var $loginWidget = $('.x-control.x-widget.x-login-widget[data-control="login"][data-type="widget"]').first();

                var redirectUrl = LhApp.Function.Url.setParameterValue('mode', 'add-review');

                $loginLink.click(function (e) {
                    $loginPopup.hide();

                    if ($loginWidget.length > 0 && $loginWidget.data('expandable') == true) {

                        var $loginForm = $('.x-login-form', $loginWidget);

                        $loginForm.data('redirect', redirectUrl);

                        $('html, body').animate({ scrollTop: $loginWidget.offset().top }, 1500);
                        LhApp.pauseScroll = true;  // chriss TODO
                        setTimeout(function () { LhApp.pauseScroll = false; }, 2000);
                        $loginWidget.get(0).expand();
                        e.stopPropagation();

                    } else {
                        document.location = LhApp.Function.Url.setParameterValueOnUrl(LhApp.Url.Page.Login, 'ReturnUrl', encodeURIComponent(redirectUrl));
                    }
                });

                $registerLink.click(function (e) {

                    document.location = LhApp.Function.Url.setParameterValueOnUrl(LhApp.Url.Page.Register, 'ReturnUrl', encodeURIComponent(redirectUrl));
                });

                $closeBtn.click(function (e) {
                    $loginPopup.hide();
                });
            }

        }


    });

    function scrollTo(whereToScroll) {
        
        var topOffset = 0;
        var $articleReviewControl = $('.x-control.x-article-reviews[data-type="reviews"]');
        if ($articleReviewControl.length == 0) throw new Error('Article review control does not exist.');

        if ($articleReviewControl.hasClass('x-tab-body')) {
            
            var tabIndex = $articleReviewControl.closest('.tab-content').data('tab-content-index');
            var $tabTitle = $articleReviewControl.closest('.x-control.x-tab-panel').find('.tab-title[data-tab-index="' + tabIndex + '"]');
            $tabTitle.trigger('click');

        }

        topOffset = $articleReviewControl.offset().top - 40;

        if (whereToScroll == 'form') {

            var $openFormLink = $articleReviewControl.find('*[data-click="open-article-review-form"]');
            if ($openFormLink.length > 0) {
                $openFormLink.trigger('click');
            } else {
                $articleReviewControl.find('*[data-click="show-login-message"]').trigger('click');
            }

        } else if (whereToScroll == 'reviews') {


        }

        $('html, body').animate({ scrollTop: topOffset }, 1500);
        LhApp.pauseScroll = true;
        setTimeout(function () { LhApp.pauseScroll = false; }, 2000);
    }
});